import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { ref } from "firebase/database";
import { listenDatabaseValue as onValue } from "../utils/listenDatabaseValue";
import { db } from "../lib/firebase";
import { useDispatchApp } from "../lib/redux";
import { getPathDatabaseByRole } from "../actions/auth";
import { ROUTE_INSIGHTS } from "../utils/constants";
import { clearBrandInsightsEnterSnapshot } from "../utils/brandInsightsLastViewed";
import {
  countNewInsights,
  getPlaybookLastSeenAt,
} from "../utils/brandInsightsUnread";

const emptyPlaybook = () => ({
  positive: [],
  negative: [],
  lastSeenAt: 0,
});

export const useBrandInsightsUnread = () => {
  const dispatch = useDispatchApp();
  const { pathBrandLearnedInsights, userID } = dispatch(
    getPathDatabaseByRole()
  );
  const { pathname } = useLocation();

  const [playbook, setPlaybook] = useState(emptyPlaybook);

  useEffect(() => {
    if (pathname !== ROUTE_INSIGHTS) {
      clearBrandInsightsEnterSnapshot(userID);
    }
  }, [pathname, userID]);

  useEffect(() => {
    if (!pathBrandLearnedInsights) {
      setPlaybook(emptyPlaybook());
      return undefined;
    }

    const playbookRef = ref(db, pathBrandLearnedInsights);
    return onValue(playbookRef, (snapshot) => {
      setPlaybook(snapshot.exists() ? snapshot.val() : emptyPlaybook());
    });
  }, [pathBrandLearnedInsights]);

  const newCount = useMemo(
    () => countNewInsights(playbook, getPlaybookLastSeenAt(playbook)),
    [playbook]
  );

  return {
    newCount,
    hasUnread: newCount > 0,
  };
};
